import { httpClient } from '@/api/httpClient';
import {
  mapPaginatedResource,
  type PaginatedApiResource,
  type PaginatedResult,
} from '@/api/pagination.types';
import {
  mapApiResourceToPermission,
  mapApiResourceToRole,
  mapApiResourceToRoleDetail,
  type CreateRolePayload,
  type Permission,
  type PermissionApiResource,
  type Role,
  type RoleApiResource,
  type RoleDetail,
  type RoleDetailApiResource,
} from './accessApi.types';

export async function fetchPermissions(): Promise<Permission[]> {
  const response = await httpClient.get<PermissionApiResource[]>('/permissions');
  return response.data.map(mapApiResourceToPermission);
}

export async function fetchRoles(
  page: number,
  pageSize: number,
  search: string,
  scopeCode?: string
): Promise<PaginatedResult<Role>> {
  const trimmedSearch = search.trim();
  const response = await httpClient.get<PaginatedApiResource<RoleApiResource>>('/roles', {
    params: {
      page,
      page_size: pageSize,
      search: trimmedSearch.length === 0 ? undefined : trimmedSearch,
      scope_code: scopeCode,
    },
  });
  return mapPaginatedResource(response.data, mapApiResourceToRole);
}

export async function fetchRoleDetail(roleId: string): Promise<RoleDetail> {
  const response = await httpClient.get<RoleDetailApiResource>('/roles/' + roleId);
  return mapApiResourceToRoleDetail(response.data);
}

export async function createRole(payload: CreateRolePayload): Promise<RoleDetail> {
  const response = await httpClient.post<RoleDetailApiResource>('/roles', {
    name: payload.name,
    description: payload.description,
    scope_code: payload.scopeCode,
    permission_ids: payload.permissionIds,
  });
  return mapApiResourceToRoleDetail(response.data);
}

export async function replaceRolePermissions(
  roleId: string,
  permissionIds: string[]
): Promise<RoleDetail> {
  const response = await httpClient.put<RoleDetailApiResource>(
    '/roles/' + roleId + '/permissions',
    { permission_ids: permissionIds }
  );
  return mapApiResourceToRoleDetail(response.data);
}
